import { ApiService } from '../../common'

export class AppTranslationsApi extends ApiService {}
